export default {
  name: 'input_text',
  component_path: 'modules/procedures/blocks/BlockInputText'
}